import { createSlice, PayloadAction } from "@reduxjs/toolkit/react";
import { ProductState } from "./product-state.interface";
import { ProductInterface } from "../../interfaces/product/product.interface";
import { initProduct } from "./thunks/init-product.thunk";


const initialState: ProductState = {
    product: {},
    translate: {}
};

const sendGtagEvent = (event: string) => {
    try {
        if (typeof window !== 'undefined' && (window as any).dataLayer) {
            (window as any).dataLayer.push({
                'event': 'streammydata_event',
                'event_params': {
                    'smd_event_name': event
                }
            });
        }
    } catch (e) {
        console.error(e);
    }
}

const readWishlistFromCookie = (productId: number): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }
    return typeof (window as any).smartWishlistHas === 'function'
        ? (window as any).smartWishlistHas(productId)
        : false;
};

const productSlice = createSlice({
    name: 'product',
    initialState,
    reducers: {
        setProduct(state: ProductState, action: PayloadAction<{ product: ProductInterface, translate: any }>) {
            state.product = action.payload.product;
            state.translate = action.payload.translate;
        },
        syncWishlistFromCookie(state: ProductState) {
            state.product.isWishlist = readWishlistFromCookie(Number(state.product.id));
        },
        changeWishlistStatus(state: ProductState, action: PayloadAction<boolean>) {
            const product = state.product;
            const next = action.payload;
            state.product.isWishlist = next;

            if (typeof window !== 'undefined' && typeof (window as any).smartWishlistSet === 'function') {
                (window as any).smartWishlistSet(product.id, next, {
                    price: product.price,
                    stockStatus: product.stockStatusId,
                });
            }
        },
        addToCart(state: ProductState) {
            console.log(state.product.subscription);

            const formData = new FormData();
            formData.append('quantity', '1');
            formData.append('product_id', String(state.product.id));

            // Add subscription
            if (state.product.subscription) {
                formData.append('subscription', String(state.product.subscription.id));
            }
            // End

            fetch('index.php?route=checkout/cart/add', {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then((json: any) => {
                    if (json.error) {
                        const { option } = json.error;
                        Object.keys(option).forEach(i => {
                            const errorElement = document.querySelector(`.option-${i}`);
                            if (errorElement) {
                                errorElement.innerHTML = `<span class="error">${option[i]}</span>`;
                            }
                        });
                        console.error('Error append to cart', json.error);
                    }

                    if(typeof window !== 'undefined') {
                        (window as any).mindboxUpdateCart();
                        if (json.success) {
                            (window as any).popup_open_cart_succes();
                            window.location.href = "index.php?route=checkout/cart";
                        }
                    }
                });

            sendGtagEvent('mn_add_to_cart');
        },
        gtag(_: ProductState, action: PayloadAction<string>) {
            sendGtagEvent(action.payload);
        },
        sendCallEvent(state: ProductState, action:PayloadAction<{ telephone: string, event: string }>) {
            if(typeof window !== 'undefined') {
                const data = {
                    event: action.payload.event,
                    roistat_visit: (window as any)?.roistat?.getVisit(),
                    roistat_source: (window as any)?.roistat?.getSource(),
                    page_path: (window as any).location.href,
                    product_id: state.product.id,
                    telephone: action.payload.telephone?.replace(/\D/g, '')
                };

                fetch('index.php?route=product/product/supportCallEvent', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data),
                });
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(initProduct.rejected, (state) => {
            const product = state.product;
            state.product = { ...product, needUpdate: false }
        })
        builder.addCase(initProduct.fulfilled, (state, action) => {
            state.product = action.payload;
        });
    }
});

export const { sendCallEvent, setProduct, syncWishlistFromCookie, gtag, changeWishlistStatus, addToCart } = productSlice.actions;
export default productSlice.reducer;